<ul class="user-profile-menu list-group">
  <li class="list-group-item menu-title">{{ 'module.shared.userProfileMenu.userPreferencesMenuTitleText' | translate }}</li>
  <li class="list-group-item" (click)="goTo(['einstellungen', 'meine-persönlichen-daten'])" *ngIf="!userStore.hasPermission('DSO_PERSONAL_DATA')">
    <a>
      <span class="sub-menu-icon fa fa-user"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.myPersonalDataSubMenuText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="goTo(['dso', 'einstellungen', 'meine-persönlichen-daten'])" *ngIf="!!userStore.hasPermission('DSO_PERSONAL_DATA')">
    <a>
      <span class="sub-menu-icon fa fa-user"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.myPersonalDataSubMenuText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="goTo(['einstellungen', 'benutzerverwaltung'])" *ngIf="!!authService.permissions?.USER_MANAGEMENT">
    <a>
      <span class="sub-menu-icon fa fa-user-plus"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.manageUserText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="goTo(['dso', 'einstellungen', 'benutzerverwaltung'])" *ngIf="!!userStore.hasPermission('DSO_USER_MANAGEMENT')">
    <a>
      <span class="sub-menu-icon fa fa-user-plus"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.manageUserText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" *ngIf="!!authService.permissions?.RELEASE_NOTE_ADMIN" (click)="goTo(['einstellungen', 'neuerungen-verwalten'])">
    <span class="sub-menu-icon fa fa-list-alt"></span>
    <a>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.releaseNoteAdminText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="goTo(['einstellungen', 'kommunen-onboarding'])" *ngIf="!!userStore.hasPermission('KOMMUNEN_ONBOARDING')">
    <a>
      <app-svg-icon class="sub-menu-icon" src="./assets/icons/ico_kommunen_onboarding.svg"></app-svg-icon>
      <!-- change icon name -->
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.regionManagementText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" *ngIf="!!authService.permissions?.GENERAL_CONFIGURATION" (click)="goTo(['einstellungen', 'kommunenverwaltung'])">
    <span class="sub-menu-icon fa fa-cog"></span>
    <a>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.generalConfigurationSubMenuText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" *ngIf="!!authService.permissions?.REGION_MANAGEMENT" (click)="goTo(['einstellungen', 'regionenverwaltung'])">
    <a>
      <span class="fa fa-sitemap sub-menu-icon" alt="Regionenverwaltung" title="Regionenverwaltung"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.editRegionSubMenuText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="downloadReleaseNotes()" *ngIf="environment.environment !== 'production'">
    <a>
      <span class="fa fa-info-circle sub-menu-icon version" alt="Versionsinformation" title="Versionsinformation"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.versionsInformationSubMenuText' | translate }}</span>
    </a>
  </li>
  <li class="list-group-item" (click)="logout()">
    <a>
      <span class="sub-menu-icon fa fa-sign-out"></span>
      <span class="sub-menu-text">{{ 'module.shared.userProfileMenu.logOutSubMenuText' | translate }}</span>
    </a>
  </li>
</ul>
